export type MajorType = {
  label: string,
  value: string,
};

export const COURSE_MAJOR_CIP: MajorType[] = [
  { 
    label: 'Agricultural Business and Management', 
    value: '01.01' 
  },{ 
    label: 'Agricultural Mechanization', 
    value: '01.02' 
  }, { 
    label: 'Agricultural Production Operations', 
    value: '01.03' 
  }, { 
    label: 'Agricultural and Food Products Processing', 
    value: '01.04' 
  }, { 
    label: 'Agricultural and Domestic Animal Services', 
    value: '01.05' 
  }, { 
    label: 'Applied Horticulture and Horticultural Business Services', 
    value: '01.06' 
  }, { 
    label: 'International Agriculture', 
    value: '01.07' 
  }, { 
    label: 'Agricultural Public Services', 
    value: '01.08' 
  }, { 
    label: 'Animal Sciences', 
    value: '01.09' 
  }, { 
    label: 'Food Science and Technology', 
    value: '01.10' 
  }, { 
    label: 'Plant Sciences', 
    value: '01.11' 
  }, { 
    label: 'Soil Sciences', 
    value: '01.12' 
  }, { 
    label: 'Agriculture/Veterinary Preparatory Programs', 
    value: '01.13' 
  }, { 
    label: 'Veterinary Medicine', 
    value: '01.80' 
  }, { 
    label: 'Veterinary Biomedical and Clinical Sciences', 
    value: '01.81' 
  }, { 
    label: 'Veterinary Administrative Services', 
    value: '01.82' 
  }, { 
    label: 'Veterinary/Animal Health Technologies/Technicians', 
    value: '01.83' 
  }, { 
    label: 'Agricultural/Animal/Plant/Veterinary Science and Related Fields, Other', 
    value: '01.99' 
  }, { 
    label: 'Natural Resources Conservation and Research', 
    value: '03.01' 
  }, { 
    label: 'Environmental/Natural Resources Management and Policy', 
    value: '03.02' 
  }, { 
    label: 'Fishing and Fisheries Sciences and Management', 
    value: '03.03' 
  }, { 
    label: 'Forestry', 
    value: '03.05' 
  }, { 
    label: 'Wildlife and Wildlands Science and Management', 
    value: '03.06' 
  }, { 
    label: 'Natural Resources and Conservation, Other', 
    value: '03.99' 
  }, { 
    label: 'Architecture', 
    value: '04.02' 
  }, { 
    label: 'City/Urban, Community, and Regional Planning', 
    value: '04.03' 
  }, { 
    label: 'Environmental Design', 
    value: '04.04' 
  }, { 
    label: 'Interior Architecture', 
    value: '04.05' 
  }, { 
    label: 'Landscape Architecture', 
    value: '04.06' 
  }, { 
    label: 'Architectural History, Criticism, and Conservation', 
    value: '04.08' 
  }, { 
    label: 'Architectural Sciences and Technology', 
    value: '04.09' 
  }, { 
    label: 'Real Estate Development', 
    value: '04.10' 
  }, { 
    label: 'Architecture and Related Services, Other', 
    value: '04.99' 
  }, { 
    label: 'Area Studies', 
    value: '05.01' 
  }, { 
    label: 'Ethnic, Cultural Minority, Gender, and Group Studies', 
    value: '05.02' 
  }, { 
    label: 'Area, Ethnic, Cultural, Gender, and Group Studies, Other', 
    value: '05.99' 
  }, { 
    label: 'Communication and Media Studies', 
    value: '09.01' 
  }, { 
    label: 'Journalism', 
    value: '09.04' 
  }, { 
    label: 'Radio, Television, and Digital Communication', 
    value: '09.07' 
  }, { 
    label: 'Public Relations, Advertising, and Applied Communication', 
    value: '09.09' 
  }, { 
    label: 'Publishing', 
    value: '09.10' 
  }, { 
    label: 'Communication, Journalism, and Related Programs, Other', 
    value: '09.99' 
  }, { 
    label: 'Communications Technologies/Technicians', 
    value: '10.01' 
  }, { 
    label: 'Audiovisual Communications Technologies/Technicians.', 
    value: '10.02' 
  }, { 
    label: 'Graphic Communications', 
    value: '10.03' 
  }, { 
    label: 'Communications Technologies/Technicians and Support Services, Other', 
    value: '10.99' 
  }, { 
    label: 'Computer and Information Sciences, General', 
    value: '11.01' 
  }, { 
    label: 'Computer Programming', 
    value: '11.02' 
  }, { 
    label: 'Data Processing', 
    value: '11.03' 
  }, { 
    label: 'Information Science/Studies', 
    value: '11.04' 
  }, { 
    label: 'Computer Systems Analysis', 
    value: '11.05' 
  }, { 
    label: 'Data Entry/Microcomputer Applications', 
    value: '11.06' 
  }, { 
    label: 'Computer Science', 
    value: '11.07' 
  }, { 
    label: 'Computer Software and Media Applications', 
    value: '11.08' 
  }, { 
    label: 'Computer Systems Networking and Telecommunications', 
    value: '11.09' 
  }, { 
    label: 'Computer/Information Technology Administration and Management', 
    value: '11.10' 
  }, { 
    label: 'Computer and Information Sciences and Support Services, Other', 
    value: '11.99' 
  }, { 
    label: 'Funeral Service and Mortuary Science', 
    value: '12.03' 
  }, { 
    label: 'Cosmetology and Related Personal Grooming Services', 
    value: '12.04' 
  }, { 
    label: 'Culinary Arts and Related Services', 
    value: '12.05' 
  }, { 
    label: 'Casino Operations and Services', 
    value: '12.06' 
  }, { 
    label: 'Culinary, Entertainment, and Personal Services, Other', 
    value: '12.99' 
  }, { 
    label: 'Education, General', 
    value: '13.01' 
  }, { 
    label: 'Bilingual, Multilingual, and Multicultural Education', 
    value: '13.02' 
  }, { 
    label: 'Curriculum and Instruction', 
    value: '13.03' 
  }, { 
    label: 'Educational Administration and Supervision', 
    value: '13.04' 
  }, { 
    label: 'Educational/Instructional Media Design', 
    value: '13.05' 
  }, { 
    label: 'Educational Assessment, Evaluation, and Research', 
    value: '13.06' 
  }, { 
    label: 'International and Comparative Education', 
    value: '13.07' 
  }, { 
    label: 'Social and Philosophical Foundations of Education', 
    value: '13.09' 
  }, { 
    label: 'Special Education and Teaching', 
    value: '13.10' 
  }, { 
    label: 'Student Counseling and Personnel Services', 
    value: '13.11' 
  }, { 
    label: 'Teacher Education and Professional Development, Specific Levels and Methods', 
    value: '13.12' 
  }, { 
    label: 'Teacher Education and Professional Development, Specific Subject Areas', 
    value: '13.13' 
  }, { 
    label: 'Teaching English or French as a Second or Foreign Language', 
    value: '13.14' 
  }, { 
    label: 'Teaching Assistants/Aides', 
    value: '13.15' 
  }, { 
    label: 'Education, Other', 
    value: '13.99' 
  }, { 
    label: 'Engineering, General', 
    value: '14.01' 
  }, { 
    label: 'Aerospace, Aeronautical, and Astronautical/Space Engineering', 
    value: '14.02' 
  }, { 
    label: 'Agricultural Engineering', 
    value: '14.03' 
  }, { 
    label: 'Architectural Engineering', 
    value: '14.04' 
  }, { 
    label: 'Biomedical/Medical Engineering', 
    value: '14.05' 
  }, { 
    label: 'Ceramic Sciences and Engineering', 
    value: '14.06' 
  }, { 
    label: 'Chemical Engineering', 
    value: '14.07' 
  }, { 
    label: 'Civil Engineering', 
    value: '14.08' 
  }, { 
    label: 'Computer Engineering', 
    value: '14.09' 
  }, { 
    label: 'Electrical, Electronics, and Communications Engineering', 
    value: '14.10' 
  }, { 
    label: 'Engineering Mechanics', 
    value: '14.11' 
  }, { 
    label: 'Engineering Physics', 
    value: '14.12' 
  }, {
    label: 'Engineering Science', 
    value: '14.13' 
  }, {
    label: 'Environmental/Environmental Health Engineering', 
    value: '14.14' 
  }, {
    label: 'Materials Engineering', 
    value: '14.18' 
  }, {
    label: 'Mechanical Engineering', 
    value: '14.19' 
  }, {
    label: 'Metallurgical Engineering', 
    value: '14.20' 
  }, {
    label: 'Mining and Mineral Engineering', 
    value: '14.21' 
  }, {
    label: 'Naval Architecture and Marine Engineering', 
    value: '14.22' 
  }, {
    label: 'Nuclear Engineering', 
    value: '14.23' 
  }, {
    label: 'Ocean Engineering', 
    value: '14.24' 
  }, {
    label: 'Petroleum Engineering', 
    value: '14.25' 
  }, {
    label: 'Systems Engineering', 
    value: '14.27' 
  }, {
    label: 'Textile Sciences and Engineering', 
    value: '14.28' 
  }, {
    label: 'Polymer/Plastics Engineering', 
    value: '14.32' 
  }, {
    label: 'Construction Engineering', 
    value: '14.33' 
  }, {
    label: 'Forest Engineering', 
    value: '14.34' 
  }, {
    label: 'Industrial Engineering', 
    value: '14.35' 
  }, {
    label: 'Manufacturing Engineering', 
    value: '14.36' 
  }, {
    label: 'Operations Research', 
    value: '14.37' 
  }, {
    label: 'Surveying Engineering', 
    value: '14.38' 
  }, {
    label: 'Geological/Geophysical Engineering', 
    value: '14.39' 
  }, {
    label: 'Paper Science and Engineering', 
    value: '14.40' 
  }, {
    label: 'Electromechanical Engineering', 
    value: '14.41' 
  }, {
    label: 'Mechatronics, Robotics, and Automation Engineering', 
    value: '14.42' 
  }, {
    label: 'Biochemical Engineering', 
    value: '14.43' 
  }, {
    label: 'Engineering Chemistry', 
    value: '14.44' 
  }, {
    label: 'Biological/Biosystems Engineering', 
    value: '14.45' 
  }, {
    label: 'Electrical and Computer Engineering', 
    value: '14.47' 
  }, {
    label: 'Energy Systems Engineering', 
    value: '14.48' 
  }, {
    label: 'Engineering, Other', 
    value: '14.99' 
  }, {
    label: 'Architectural Engineering Technologies/Technicians', 
    value: '15.01' 
  }, {
    label: 'Civil Engineering Technologies/Technicians', 
    value: '15.02' 
  }, {
    label: 'Electrical/Electronic Engineering Technologies/Technicians', 
    value: '15.03' 
  }, {
    label: 'Electromechanical Technologies/Technicians', 
    value: '15.04' 
  }, {
    label: 'Environmental Control Technologies/Technicians', 
    value: '15.05' 
  }, {
    label: 'Industrial Production Technologies/Technicians', 
    value: '15.06' 
  }, {
    label: 'Quality Control and Safety Technologies/Technicians', 
    value: '15.07' 
  }, {
    label: 'Mechanical Engineering Related Technologies/Technicians', 
    value: '15.08' 
  }, {
    label: 'Mining and Petroleum Technologies/Technicians', 
    value: '15.09' 
  }, {
    label: 'Construction Engineering Technology/Technician', 
    value: '15.10' 
  }, {
    label: 'Engineering-Related Technologies/Technicians', 
    value: '15.11' 
  }, {
    label: 'Computer Engineering Technologies/Technicians', 
    value: '15.12' 
  }, {
    label: 'Drafting/Design Engineering Technologies/Technicians', 
    value: '15.13' 
  }, {
    label: 'Nuclear Engineering Technology/Technician', 
    value: '15.14' 
  }, {
    label: 'Engineering-Related Fields', 
    value: '15.15' 
  }, {
    label: 'Nanotechnology', 
    value: '15.16' 
  }, {
    label: 'Energy Systems Technologies/Technicians', 
    value: '15.17' 
  }, {
    label: 'Engineering/Engineering-Related Technologies/Technicians, Other', 
    value: '15.99' 
  }, {
    label: 'Linguistic, Comparative, and Related Language Studies and Services', 
    value: '16.01' 
  }, {
    label: 'African Languages, Literatures, and Linguistics', 
    value: '16.02' 
  }, {
    label: 'East Asian Languages, Literatures, and Linguistics', 
    value: '16.03' 
  }, {
    label: 'Slavic, Baltic and Albanian Languages, Literatures, and Linguistics', 
    value: '16.04' 
  }, {
    label: 'Germanic Languages, Literatures, and Linguistics', 
    value: '16.05' 
  }, {
    label: 'Modern Greek Language and Literature', 
    value: '16.06' 
  }, {
    label: 'South Asian Languages, Literatures, and Linguistics', 
    value: '16.07' 
  }, {
    label: 'Iranian/Persian Languages, Literatures, and Linguistics', 
    value: '16.08' 
  }, {
    label: 'Romance Languages, Literatures, and Linguistics', 
    value: '16.09' 
  }, {
    label: 'American Indian/Native American Languages, Literatures, and Linguistics', 
    value: '16.10' 
  }, {
    label: 'Middle/Near Eastern and Semitic Languages, Literatures, and Linguistics', 
    value: '16.11' 
  }, {
    label: 'Classics and Classical Languages, Literatures, and Linguistics', 
    value: '16.12' 
  }, {
    label: 'Celtic Languages, Literatures, and Linguistics', 
    value: '16.13' 
  }, {
    label: 'Southeast Asian and Australasian/Pacific Languages, Literatures, and Linguistics', 
    value: '16.14' 
  }, {
    label: 'Turkic, Uralic-Altaic, Caucasian, and Central Asian Languages, Literatures, and Linguistics', 
    value: '16.15' 
  }, {
    label: 'American Sign Language', 
    value: '16.16' 
  }, {
    label: 'Second Language Learning', 
    value: '16.17' 
  }, {
    label: 'Armenian Languages, Literatures, and Linguistics', 
    value: '16.18' 
  }, {
    label: 'Foreign Languages, Literatures, and Linguistics, Other', 
    value: '16.99' 
  }, {
    label: 'Family and Consumer Sciences/Human Sciences, General', 
    value: '19.01' 
  }, {
    label: 'Family and Consumer Sciences/Human Sciences Business Services', 
    value: '19.02' 
  }, {
    label: 'Family and Consumer Economics and Related Studies', 
    value: '19.04' 
  }, {
    label: 'Foods, Nutrition, and Related Services', 
    value: '19.05' 
  }, {
    label: 'Housing and Human Environments', 
    value: '19.06' 
  }, {
    label: 'Human Development, Family Studies, and Related Services', 
    value: '19.07' 
  }, {
    label: 'Apparel and Textiles', 
    value: '19.09' 
  }, {
    label: 'Work and Family Studies', 
    value: '19.10' 
  }, {
    label: 'Family and Consumer Sciences/Human Sciences, Other', 
    value: '19.99' 
  }, {
    label: 'Reserved', 
    value: '21.01' 
  }, {
    label: 'Law', 
    value: '22.01' 
  }, {
    label: 'Legal Research and Advanced Professional Studies', 
    value: '22.02' 
  }, {
    label: 'Legal Support Services', 
    value: '22.03' 
  }, {
    label: 'Legal Professions and Studies, Other', 
    value: '22.99' 
  }, {
    label: 'English Language and Literature, General', 
    value: '23.01' 
  }, {
    label: 'Rhetoric and Composition/Writing Studies', 
    value: '23.13' 
  }, {
    label: 'Literature', 
    value: '23.14' 
  }, {
    label: 'English Language and Literature/Letters, Other', 
    value: '23.99' 
  }, {
    label: 'Liberal Arts and Sciences, General Studies and Humanities', 
    value: '24.01' 
  }, {
    label: 'Library Science and Administration', 
    value: '25.01' 
  }, {
    label: 'Library and Archives Assisting', 
    value: '25.03' 
  }, {
    label: 'Library Science, Other', 
    value: '25.99' 
  }, {
    label: 'Biology, General', 
    value: '26.01' 
  }, {
    label: 'Biochemistry, Biophysics and Molecular Biology', 
    value: '26.02' 
  }, {
    label: 'Botany/Plant Biology', 
    value: '26.03' 
  }, {
    label: 'Cell/Cellular Biology and Anatomical Sciences', 
    value: '26.04' 
  }, {
    label: 'Microbiological Sciences and Immunology', 
    value: '26.05' 
  }, {
    label: 'Zoology/Animal Biology', 
    value: '26.07' 
  }, {
    label: 'Genetics', 
    value: '26.08' 
  }, {
    label: 'Physiology, Pathology and Related Sciences', 
    value: '26.09' 
  }, {
    label: 'Pharmacology and Toxicology', 
    value: '26.10' 
  }, {
    label: 'Biomathematics, Bioinformatics, and Computational Biology', 
    value: '26.11' 
  }, {
    label: 'Biotechnology', 
    value: '26.12' 
  }, {
    label: 'Ecology, Evolution, Systematics, and Population Biology', 
    value: '26.13' 
  }, {
    label: 'Molecular Medicine', 
    value: '26.14' 
  }, {
    label: 'Neurobiology and Neurosciences', 
    value: '26.15' 
  }, {
    label: 'Biological and Biomedical Sciences, Other', 
    value: '26.99' 
  }, {
    label: 'Mathematics', 
    value: '27.01' 
  }, {
    label: 'Applied Mathematics', 
    value: '27.03' 
  }, {
    label: 'Statistics', 
    value: '27.05' 
  }, {
    label: 'Applied Statistics', 
    value: '27.06' 
  }, {
    label: 'Mathematics and Statistics, Other', 
    value: '27.99' 
  }, {
    label: 'Air Force ROTC, Air Science and Operations', 
    value: '28.01' 
  }, {
    label: 'Army ROTC, Military Science and Operations', 
    value: '28.03' 
  }, {
    label: 'Navy/Marine ROTC, Naval Science and Operations', 
    value: '28.04' 
  }, {
    label: 'Military Science and Operational Studies', 
    value: '28.05' 
  }, {
    label: 'Security Policy and Strategy', 
    value: '28.06' 
  }, {
    label: 'Military Economics and Management', 
    value: '28.07' 
  }, {
    label: 'Reserved', 
    value: '28.08' 
  }, {
    label: 'Military Science, Leadership and Operational Art, Other', 
    value: '28.99' 
  }, {
    label: 'Intelligence, Command Control and Information Operations', 
    value: '29.02' 
  }, {
    label: 'Military Applied Sciences', 
    value: '29.03' 
  }, {
    label: 'Military Systems and Maintenance Technology', 
    value: '29.04' 
  }, {
    label: 'Reserved', 
    value: '29.05' 
  }, {
    label: 'Military Technology and Applied Sciences Management', 
    value: '29.06' 
  }, {
    label: 'Military Technologies and Applied Sciences, Other', 
    value: '29.99' 
  }, {
    label: 'Biological and Physical Sciences', 
    value: '30.01' 
  }, {
    label: 'Peace Studies and Conflict Resolution', 
    value: '30.05' 
  }, {
    label: 'Systems Science and Theory', 
    value: '30.06' 
  }, {
    label: 'Mathematics and Computer Science', 
    value: '30.08' 
  }, {
    label: 'Biopsychology', 
    value: '30.10' 
  }, {
    label: 'Gerontology', 
    value: '30.11' 
  }, {
    label: 'Historic Preservation and Conservation', 
    value: '30.12' 
  }, {
    label: 'Medieval and Renaissance Studies', 
    value: '30.13' 
  }, {
    label: 'Museology/Museum Studies', 
    value: '30.14' 
  }, {
    label: 'Science, Technology and Society', 
    value: '30.15' 
  }, {
    label: 'Accounting and Computer Science', 
    value: '30.16' 
  }, {
    label: 'Behavioral Sciences', 
    value: '30.17' 
  }, {
    label: 'Natural Sciences', 
    value: '30.18' 
  }, {
    label: 'Nutrition Sciences', 
    value: '30.19' 
  }, {
    label: 'International/Globalization Studies', 
    value: '30.20' 
  }, {
    label: 'Holocaust and Related Studies', 
    value: '30.21' 
  }, {
    label: 'Classical and Ancient Studies', 
    value: '30.22' 
  }, {
    label: 'Intercultural/Multicultural and Diversity Studies', 
    value: '30.23' 
  }, {
    label: 'Cognitive Science', 
    value: '30.25' 
  }, {
    label: 'Cultural Studies/Critical Theory and Analysis', 
    value: '30.26' 
  }, {
    label: 'Human Biology', 
    value: '30.27' 
  }, {
    label: 'Dispute Resolution', 
    value: '30.28' 
  }, {
    label: 'Maritime Studies', 
    value: '30.29' 
  }, {
    label: 'Computational Science', 
    value: '30.30' 
  }, {
    label: 'Human Computer Interaction', 
    value: '30.31' 
  }, {
    label: 'Marine Sciences', 
    value: '30.32' 
  }, {
    label: 'Sustainability Studies', 
    value: '30.33' 
  }, {
    label: 'Anthrozoology', 
    value: '30.34' 
  }, {
    label: 'Climate Science', 
    value: '30.35' 
  }, {
    label: 'Cultural Studies and Comparative Literature', 
    value: '30.36' 
  }, {
    label: 'Design for Human Health', 
    value: '30.37' 
  }, {
    label: 'Earth Systems Science', 
    value: '30.38' 
  }, {
    label: 'Economics and Computer Science', 
    value: '30.39' 
  }, {
    label: 'Economics and Foreign Language/Literature', 
    value: '30.40' 
  }, {
    label: 'Environmental Geosciences', 
    value: '30.41' 
  }, {
    label: 'Geoarcheaology', 
    value: '30.42' 
  }, {
    label: 'Geobiology', 
    value: '30.43' 
  }, {
    label: 'Geography and Environmental Studies', 
    value: '30.44' 
  }, {
    label: 'History and Language/Literature', 
    value: '30.45' 
  }, {
    label: 'History and Political Science', 
    value: '30.46' 
  }, {
    label: 'Linguistics and Anthropology', 
    value: '30.47' 
  }, {
    label: 'Linguistics and Computer Science', 
    value: '30.48' 
  }, {
    label: 'Mathematical Economics', 
    value: '30.49' 
  }, {
    label: 'Mathematics and Atmospheric/Oceanic Science', 
    value: '30.50' 
  }, {
    label: 'Philosophy, Politics, and Economics', 
    value: '30.51' 
  }, {
    label: 'Digital Humanities and Textual Studies', 
    value: '30.52' 
  }, {
    label: 'Thanatology', 
    value: '30.53' 
  }, {
    label: 'Data Science', 
    value: '30.70' 
  }, {
    label: 'Data Analytics', 
    value: '30.71' 
  }, {
    label: 'Multi/Interdisciplinary Studies, Other', 
    value: '30.99' 
  }, {
    label: 'Parks, Recreation, and Leisure Studies', 
    value: '31.01' 
  }, {
    label: 'Parks, Recreation, and Leisure Facilities Management', 
    value: '31.03' 
  }, {
    label: 'Sports, Kinesiology, and Physical Education/Fitness', 
    value: '31.05' 
  }, {
    label: 'Outdoor Education', 
    value: '31.06' 
  }, {
    label: 'Parks, Recreation, Leisure, Fitness, and Kinesiology, Other', 
    value: '31.99' 
  }, {
    label: 'Basic Skills and Developmental/Remedial Education', 
    value: '32.01' 
  }, {
    label: 'General Exam Preparation and Test-Taking Skills', 
    value: '32.02' 
  }, {
    label: 'Citizenship Activities', 
    value: '33.01' 
  }, {
    label: 'Health-Related Knowledge and Skills', 
    value: '34.01' 
  }, {
    label: 'Interpersonal and Social Skills', 
    value: '35.01' 
  }, {
    label: 'Leisure and Recreational Activities', 
    value: '36.01' 
  }, {
    label: 'Noncommercial Vehicle Operation', 
    value: '36.02' 
  }, {
    label: 'Personal Awareness and Self-Improvement', 
    value: '37.01' 
  }, {
    label: 'Philosophy', 
    value: '38.01' 
  }, {
    label: 'Religion/Religious Studies', 
    value: '38.02' 
  }, {
    label: 'Philosophy and Religious Studies, Other', 
    value: '38.99' 
  }, {
    label: 'Bible/Biblical Studies', 
    value: '39.02' 
  }, {
    label: 'Missions/Missionary Studies and Missiology', 
    value: '39.03' 
  }, {
    label: 'Religious Education', 
    value: '39.04' 
  }, {
    label: 'Religious Music and Worship', 
    value: '39.05' 
  }, {
    label: 'Theological and Ministerial Studies', 
    value: '39.06' 
  }, {
    label: 'Pastoral Counseling and Specialized Ministries', 
    value: '39.07' 
  }, {
    label: 'Religious Institution Administration and Law', 
    value: '39.08' 
  }, {
    label: 'Theology and Religious Vocations, Other', 
    value: '39.99' 
  }, {
    label: 'Physical Sciences, General', 
    value: '40.01' 
  }, {
    label: 'Astronomy and Astrophysics', 
    value: '40.02' 
  }, {
    label: 'Atmospheric Sciences and Meteorology', 
    value: '40.04' 
  }, {
    label: 'Chemistry', 
    value: '40.05' 
  }, {
    label: 'Geological and Earth Sciences/Geosciences', 
    value: '40.06' 
  }, {
    label: 'Physics', 
    value: '40.08' 
  }, {
    label: 'Materials Sciences', 
    value: '40.10' 
  }, {
    label: 'Physics and Astronomy', 
    value: '40.11' 
  }, {
    label: 'Physical Sciences, Other', 
    value: '40.99' 
  }, {
    label: 'Biology/Biotechnology Technologies/Technicians', 
    value: '41.01' 
  }, {
    label: 'Nuclear and Industrial Radiologic Technologies/Technicians', 
    value: '41.02' 
  }, {
    label: 'Physical Science Technologies/Technicians', 
    value: '41.03' 
  }, {
    label: 'Science Technologies/Technicians, Other', 
    value: '41.99' 
  }, {
    label: 'Psychology, General', 
    value: '42.01' 
  }, {
    label: 'Research and Experimental Psychology', 
    value: '42.27' 
  }, {
    label: 'Clinical, Counseling and Applied Psychology', 
    value: '42.28' 
  }, {
    label: 'Psychology, Other', 
    value: '42.99' 
  }, {
    label: 'Criminal Justice and Corrections', 
    value: '43.01' 
  }, {
    label: 'Fire Protection', 
    value: '43.02' 
  }, {
    label: 'Homeland Security', 
    value: '43.03' 
  }, {
    label: 'Security Science and Technology', 
    value: '43.04' 
  }, {
    label: 'Security Science and Technology, Other', 
    value: '43.99' 
  }, {
    label: 'Community Organization and Advocacy', 
    value: '44.02' 
  }, {
    label: 'Public Administration', 
    value: '44.04' 
  }, {
    label: 'Public Policy Analysis', 
    value: '44.05' 
  }, {
    label: 'Social Work', 
    value: '44.07' 
  }, {
    label: 'Public Administration and Social Service Professions, Other', 
    value: '44.99' 
  }, {
    label: 'Social Sciences, General', 
    value: '45.01' 
  }, {
    label: 'Anthropology', 
    value: '45.02' 
  }, {
    label: 'Archeology', 
    value: '45.03' 
  }, {
    label: 'Criminology', 
    value: '45.04' 
  }, {
    label: 'Demography', 
    value: '45.05' 
  }, {
    label: 'Economics', 
    value: '45.06' 
  }, {
    label: 'Geography and Cartography', 
    value: '45.07' 
  }, {
    label: 'International Relations and National Security Studies', 
    value: '45.09' 
  }, {
    label: 'Political Science and Government', 
    value: '45.10' 
  }, {
    label: 'Sociology', 
    value: '45.11' 
  }, {
    label: 'Urban Studies/Affairs', 
    value: '45.12' 
  }, {
    label: 'Sociology and Anthropology', 
    value: '45.13' 
  }, {
    label: 'Rural Sociology', 
    value: '45.14' 
  }, {
    label: 'Geography and Anthropology', 
    value: '45.15' 
  }, {
    label: 'Social Sciences, Other', 
    value: '45.99' 
  }, {
    label: 'Mason/Masonry', 
    value: '46.01' 
  }, {
    label: 'Carpenters', 
    value: '46.02' 
  }, {
    label: 'Electrical and Power Transmission Installers', 
    value: '46.03' 
  }, {
    label: 'Building/Construction Finishing, Management, and Inspection', 
    value: '46.04' 
  }, {
    label: 'Plumbing and Related Water Supply Services', 
    value: '46.05' 
  }, {
    label: 'Construction Trades, Other', 
    value: '46.99' 
  }, {
    label: 'Electrical/Electronics Maintenance and Repair Technologies/Technicians', 
    value: '47.01' 
  }, {
    label: 'Heating, Air Conditioning, Ventilation and Refrigeration Maintenance Technology/Technician (HAC, HACR, HVAC, HVACR)', 
    value: '47.02' 
  }, {
    label: 'Heavy/Industrial Equipment Maintenance Technologies/Technicians', 
    value: '47.03' 
  }, {
    label: 'Precision Systems Maintenance and Repair Technologies/Technicians', 
    value: '47.04' 
  }, {
    label: 'Vehicle Maintenance and Repair Technologies/Technicians', 
    value: '47.06' 
  }, {
    label: 'Energy Systems Maintenance and Repair Technologies/Technicians', 
    value: '47.07' 
  }, {
    label: 'Mechanic and Repair Technologies/Technicians, Other', 
    value: '47.99' 
  }, {
    label: 'Leatherworking and Upholstery', 
    value: '48.03' 
  }, {
    label: 'Precision Metal Working', 
    value: '48.05' 
  }, {
    label: 'Woodworking', 
    value: '48.07' 
  }, {
    label: 'Boilermaking/Boilermaker', 
    value: '48.08' 
  }, {
    label: 'Precision Production, Other', 
    value: '48.99' 
  }, {
    label: 'Air Transportation', 
    value: '49.01' 
  }, {
    label: 'Ground Transportation', 
    value: '49.02' 
  }, {
    label: 'Marine Transportation', 
    value: '49.03' 
  }, {
    label: 'Transportation and Materials Moving, Other', 
    value: '49.99' 
  }, {
    label: 'Visual and Performing Arts, General', 
    value: '50.01' 
  }, {
    label: 'Crafts/Craft Design, Folk Art and Artisanry', 
    value: '50.02' 
  }, {
    label: 'Dance', 
    value: '50.03' 
  }, {
    label: 'Design and Applied Arts', 
    value: '50.04' 
  }, {
    label: 'Drama/Theatre Arts and Stagecraft', 
    value: '50.05' 
  }, {
    label: 'Film/Video and Photographic Arts', 
    value: '50.06' 
  }, {
    label: 'Fine and Studio Arts', 
    value: '50.07' 
  }, {
    label: 'Music', 
    value: '50.09' 
  }, {
    label: 'Arts, Entertainment, and Media Management', 
    value: '50.10' 
  }, {
    label: 'Community/Environmental/Socially-Engaged Art', 
    value: '50.11' 
  }, {
    label: 'Visual and Performing Arts, Other', 
    value: '50.99' 
  }, {
    label: 'Chiropractic', 
    value: '51.01' 
  }, {
    label: 'Communication Disorders Sciences and Services', 
    value: '51.02' 
  }, {
    label: 'Dentistry', 
    value: '51.04' 
  }, {
    label: 'Advanced/Graduate Dentistry and Oral Sciences', 
    value: '51.05' 
  }, {
    label: 'Dental Support Services and Allied Professions', 
    value: '51.06' 
  }, {
    label: 'Health and Medical Administrative Services', 
    value: '51.07' 
  }, {
    label: 'Allied Health and Medical Assisting Services', 
    value: '51.08' 
  }, {
    label: 'Allied Health Diagnostic, Intervention, and Treatment Professions', 
    value: '51.09' 
  }, {
    label: 'Clinical/Medical Laboratory Science/Research and Allied Professions', 
    value: '51.10' 
  }, {
    label: 'Health/Medical Preparatory Programs', 
    value: '51.11' 
  }, {
    label: 'Medicine', 
    value: '51.12' 
  }, {
    label: 'Medical Clinical Sciences/Graduate Medical Studies', 
    value: '51.14' 
  }, {
    label: 'Mental and Social Health Services and Allied Professions', 
    value: '51.15' 
  }, {
    label: 'Optometry', 
    value: '51.17' 
  }, {
    label: 'Ophthalmic and Optometric Support Services and Allied Professions', 
    value: '51.18' 
  }, {
    label: 'Osteopathic Medicine/Osteopathy', 
    value: '51.19' 
  }, {
    label: 'Pharmacy, Pharmaceutical Sciences, and Administration', 
    value: '51.20' 
  }, {
    label: 'Podiatric Medicine/Podiatry', 
    value: '51.21' 
  }, {
    label: 'Public Health', 
    value: '51.22' 
  }, {
    label: 'Rehabilitation and Therapeutic Professions', 
    value: '51.23' 
  }, {
    label: 'Veterinary Medicine', 
    value: '51.24' 
  }, {
    label: 'Veterinary Biomedical and Clinical Sciences', 
    value: '51.25' 
  }, {
    label: 'Health Aides/Attendants/Orderlies', 
    value: '51.26' 
  }, {
    label: 'Medical Illustration and Informatics', 
    value: '51.27' 
  }, {
    label: 'Dietetics and Clinical Nutrition Services', 
    value: '51.31' 
  }, {
    label: 'Health Professions Education, Ethics, and Humanities', 
    value: '51.32' 
  }, {
    label: 'Alternative and Complementary Medicine and Medical Systems', 
    value: '51.33' 
  }, {
    label: 'Alternative and Complementary Medical Support Services', 
    value: '51.34' 
  }, {
    label: 'Somatic Bodywork and Related Therapeutic Services', 
    value: '51.35' 
  }, {
    label: 'Movement and Mind-Body Therapies and Education', 
    value: '51.36' 
  }, {
    label: 'Energy and Biologically Based Therapies', 
    value: '51.37' 
  }, {
    label: 'Registered Nursing, Nursing Administration, Nursing Research and Clinical Nursing', 
    value: '51.38' 
  }, {
    label: 'Practical Nursing, Vocational Nursing and Nursing Assistants', 
    value: '51.39' 
  }, {
    label: 'Health Professions and Related Clinical Sciences, Other', 
    value: '51.99' 
  }, {
    label: 'Business/Commerce, General', 
    value: '52.01' 
  }, {
    label: 'Business Administration, Management and Operations', 
    value: '52.02' 
  }, {
    label: 'Accounting and Related Services', 
    value: '52.03' 
  }, {
    label: 'Business Operations Support and Assistant Services', 
    value: '52.04' 
  }, {
    label: 'Business/Corporate Communications', 
    value: '52.05' 
  }, {
    label: 'Business/Managerial Economics', 
    value: '52.06' 
  }, {
    label: 'Entrepreneurial and Small Business Operations', 
    value: '52.07' 
  }, {
    label: 'Finance and Financial Management Services', 
    value: '52.08' 
  }, {
    label: 'Hospitality Administration/Management', 
    value: '52.09' 
  }, {
    label: 'Human Resources Management and Services', 
    value: '52.10' 
  }, {
    label: 'International Business', 
    value: '52.11' 
  }, {
    label: 'Management Information Systems and Services', 
    value: '52.12' 
  }, {
    label: 'Management Sciences and Quantitative Methods', 
    value: '52.13' 
  }, {
    label: 'Marketing', 
    value: '52.14' 
  }, {
    label: 'Real Estate', 
    value: '52.15' 
  }, {
    label: 'Taxation', 
    value: '52.16' 
  }, {
    label: 'Insurance', 
    value: '52.17' 
  }, {
    label: 'General Sales, Merchandising and Related Marketing Operations', 
    value: '52.18' 
  }, {
    label: 'Specialized Sales, Merchandising and  Marketing Operations', 
    value: '52.19' 
  }, {
    label: 'Construction Management', 
    value: '52.20' 
  }, {
    label: 'Telecommunications Management', 
    value: '52.21' 
  }, {
    label: 'Business, Management, Marketing, and Related Support Services, Other', 
    value: '52.99' 
  }, {
    label: 'High School/Secondary Diploma Programs', 
    value: '53.01' 
  }, {
    label: 'High School/Secondary Certificate Programs', 
    value: '53.02' 
  }, {
    label: 'History', 
    value: '54.01' 
  }, {
    label: 'Reserved', 
    value: '55.01' 
  }, {
    label: 'Dental Residency/Fellowship Programs', 
    value: '60.01' 
  }, {
    label: 'Veterinary Residency/Fellowship Programs', 
    value: '60.03' 
  }, {
    label: 'Medical Residency Programs - General Certificates', 
    value: '60.04' 
  }, {
    label: 'Medical Residency Programs - Subspecialty Certificates', 
    value: '60.05' 
  }, {
    label: 'Podiatric Medicine Residency Programs', 
    value: '60.06' 
  }, {
    label: 'Nurse Practitioner Residency/Fellowship Programs', 
    value: '60.07' 
  }, {
    label: 'Pharmacy Residency/Fellowship Programs', 
    value: '60.08' 
  }, {
    label: 'Physician Assistant Residency/Fellowship Programs', 
    value: '60.09' 
  }, {
    label: 'Health Professions Residency/Fellowship Programs, Other', 
    value: '60.99' 
  }, {
    label: 'Combined Medical Residency/Fellowship Programs', 
    value: '61.01' 
  }, {
    label: 'Multiple-Pathway Medical Fellowship Programs', 
    value: '61.02' 
  }, {
    label: 'Allergy and Immunology Residency/Fellowship Programs', 
    value: '61.03' 
  }, {
    label: 'Anesthesiology Residency/Fellowship Programs', 
    value: '61.04' 
  }, {
    label: 'Dermatology Residency/Fellowship Programs', 
    value: '61.05' 
  }, {
    label: 'Emergency Medicine Residency/Fellowship Programs', 
    value: '61.06' 
  }, {
    label: 'Family Medicine Residency/Fellowship Programs', 
    value: '61.07' 
  }, {
    label: 'Internal Medicine Residency/Fellowship Programs', 
    value: '61.08' 
  }, {
    label: 'Medical Genetics and Genomics Residency/Fellowship Programs', 
    value: '61.09' 
  }, {
    label: 'Neurological Surgery Residency/Fellowship Programs', 
    value: '61.10' 
  }, {
    label: 'Neurology Residency/Fellowship Programs', 
    value: '61.11' 
  }, {
    label: 'Nuclear Medicine Residency/Fellowship Programs', 
    value: '61.12' 
  }, {
    label: 'Obstetrics and Gynecology Residency/Fellowship Programs', 
    value: '61.13' 
  }, {
    label: 'Ophthalmology Residency/Fellowship Programs', 
    value: '61.14' 
  }, {
    label: 'Orthopedic Surgery Residency/Fellowship Programs', 
    value: '61.15' 
  }, {
    label: 'Osteopathic Medicine Residency/Fellowship Programs', 
    value: '61.16' 
  }, {
    label: 'Otolaryngology Residency/Fellowship Programs', 
    value: '61.17' 
  }, {
    label: 'Pathology Residency/Fellowship Programs', 
    value: '61.18' 
  }, {
    label: 'Pediatrics Residency/Fellowship Programs', 
    value: '61.19' 
  }, {
    label: 'Physical Medicine and Rehabilitation Residency/Fellowship Programs', 
    value: '61.20' 
  }, {
    label: 'Plastic Surgery Residency/Fellowship Programs', 
    value: '61.21' 
  }, {
    label: 'Podiatric Medicine Residency/Fellowship Programs', 
    value: '61.22' 
  }, {
    label: 'Preventive Medicine Residency/Fellowship Programs', 
    value: '61.23' 
  }, {
    label: 'Psychiatry Residency/Fellowship Programs', 
    value: '61.24' 
  }, {
    label: 'Radiation Oncology Residency/Fellowship Programs', 
    value: '61.25' 
  }, {
    label: 'Radiology Residency/Fellowship Programs', 
    value: '61.26' 
  }, {
    label: 'Surgery Residency/Fellowship Programs', 
    value: '61.27' 
  }, {
    label: 'Urology Residency/Fellowship Programs', 
    value: '61.28' 
  }, {
    label: 'Medical Residency/Fellowship Programs, Other', 
    value: '61.99' 
  },
];